import { useEffect } from 'react';

/**
 * Sets document.title, meta description, and canonical for the current page.
 * Layout-safe: only updates head elements; never touches the DOM body.
 */
export default function usePageMeta({ title, description, path = '' }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }

    const url = `https://ballraw.com${path || (typeof window !== 'undefined' ? window.location.pathname : '')}`;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    // OpenGraph + Twitter
    const setMeta = (selector, attrName, attrValue, content) => {
      let m = document.head.querySelector(selector);
      if (!m) {
        m = document.createElement('meta');
        m.setAttribute(attrName, attrValue);
        document.head.appendChild(m);
      }
      m.setAttribute('content', content);
    };
    if (title) {
      setMeta('meta[property="og:title"]', 'property', 'og:title', title);
      setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', title);
    }
    if (description) {
      setMeta('meta[property="og:description"]', 'property', 'og:description', description);
      setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description);
    }
    setMeta('meta[property="og:url"]', 'property', 'og:url', url);
    setMeta('meta[property="og:type"]', 'property', 'og:type', 'website');
    setMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');
  }, [title, description, path]);
}
